import { useContext } from 'react';

import Button from 'components/common/Button';
import Text from 'components/common/Text';
import { CustomerReportContext } from 'components/grace/Contexts';
import Chat from 'components/icons/illustrative/Chat';
import { UserContext } from 'components/signUpFunnel/Contexts';
import Logo from 'components/signUpFunnel/Logo';
import { BrandContext } from 'context/BrandContext';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import { MODAL_TYPES } from 'lib/constants';

const FooterContent = () => {
  const { brand } = useContext(BrandContext);
  const userContext = useContext(UserContext);
  const user = userContext?.user;
  const isUserLoaded = user !== undefined;
  const hasUserCompletedSignup = user?.completedSignup;
  const customerReportContext = useContext(CustomerReportContext);

  const currentYear = new Date().getFullYear();

  const openAdaDirectly = async () => {
    if (window.adaEmbed) {
      await window.adaEmbed.start(window.adaSettings);
      await window.adaEmbed.toggle();
    }
  };

  const handleOnClick = useAnalyticsCallback(
    () => {
      if (!customerReportContext) {
        openAdaDirectly();
        return;
      }

      if (isUserLoaded && hasUserCompletedSignup) {
        customerReportContext.startReport();
      } else {
        customerReportContext.setCurrentModal(MODAL_TYPES.actual_ada);
      }
    },
    ({ logEvent, events }) => {
      logEvent(events.grace.openModalClicked);
    },
    [isUserLoaded, hasUserCompletedSignup, customerReportContext]
  );

  if (!brand) return null;

  return (
    <div className="mx-auto flex w-full max-w-[1400px] flex-row-reverse items-center justify-start px-6 py-4">
      <div className="ml-auto">
        <Text className="text-normal flex items-center justify-center gap-1 text-charcoal-90">
          Need help?{' '}
          <Button
            onClick={handleOnClick}
            variation="TextPrimary"
            className="inline-flex items-center gap-1 p-0 hover:underline"
          >
            <Chat className="h-5 w-5" />
            Chat with us
          </Button>
        </Text>
        <Text className="textSm hidden w-fit text-charcoal-90 bp1:block">
          ©2013 - {currentYear}, Relish Labs LLC
        </Text>
      </div>
      <div className="mr-auto max-w-[300px]">
        <Logo />
      </div>
    </div>
  );
};

export default FooterContent;
